import { Widget } from "@foretagsplatsen/widgetjs";
import ToggableWidget from "../ToggableWidget/ToggableWidget.js";

/**
 * `flipWidget` contains two renderables, only one of them being
 * rendered at a time. To change the rendered one, send the `toggle()`
 * message.
 *
 * @param {Renderable} frontRenderable - A renderable to show by
 * default and that gets hidden when backRenderable becomes visible.
 * @param {Renderable} backRenderable - A renderable to hide by
 * default and that becomes visible when frontRenderable is hidden.
 */
export default class FlipWidget extends Widget {
	constructor({ frontRenderable, backRenderable }) {
		super(...arguments);

		this._frontRenderable = frontRenderable;
		this._backRenderable = backRenderable;

		this._toggableWidget1 = new ToggableWidget({
			visible: true,
			content: this._frontRenderable,
		});

		this._toggableWidget2 = new ToggableWidget({
			visible: false,
			content: this._backRenderable,
		});
	}

	renderContentOn(html) {
		html.render(this._toggableWidget1, this._toggableWidget2);
	}

	toggle() {
		this._toggableWidget1.toggle();
		this._toggableWidget2.toggle();
	}

	showFront() {
		return Promise.all([
			this._toggableWidget1.show(),
			this._toggableWidget2.hide(),
		]);
	}

	showBack() {
		return Promise.all([
			this._toggableWidget1.hide(),
			this._toggableWidget2.show(),
		]);
	}
}
